// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": () => import("/home/friedolin/git/friedolinfoerder/node_modules/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */),
  "component---src-templates-blog-post-js": () => import("/home/friedolin/git/friedolinfoerder/src/templates/blog-post.js" /* webpackChunkName: "component---src-templates-blog-post-js" */),
  "component---src-templates-blog-post-amp-js": () => import("/home/friedolin/git/friedolinfoerder/src/templates/blog-post.amp.js" /* webpackChunkName: "component---src-templates-blog-post-amp-js" */),
  "component---src-pages-404-js": () => import("/home/friedolin/git/friedolinfoerder/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

